import { Award, MapPin } from "lucide-react";
export default function TheCraftsmansStandard() {
  return <section id="the-craftsmans-standard" className="dark bg-background text-foreground py-16 border-y border-border/10">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-0 items-center divide-y md:divide-y-0 md:divide-x divide-border/20">
          
          {}
          <div className="flex flex-col items-center text-center md:flex-row md:text-left md:justify-center gap-5 py-8 md:py-0 md:px-8 first:pt-0 md:first:pl-0">
            <div className="bg-primary/10 p-3.5 rounded-lg ring-1 ring-primary/20 shadow-inner">
              <Award className="size-7 text-primary" strokeWidth={1.5} />
            </div>
            <div>
              <h3 className="font-default text-lg font-semibold tracking-tight text-foreground">
                Licensed & Insured
              </h3>
              <p className="text-sm text-muted-foreground mt-1">
                Residential General Contractor
              </p>
            </div>
          </div>

          {}
          <div className="flex items-center justify-center py-10 md:py-0 md:px-8">
            <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-center leading-tight"></h2>
          </div>

          {}
          <div className="flex flex-col items-center text-center md:flex-row md:text-left md:justify-center gap-5 py-8 md:py-0 md:px-8 last:pb-0 md:last:pr-0">
            <div className="bg-primary/10 p-3.5 rounded-lg ring-1 ring-primary/20 shadow-inner">
              <MapPin className="size-7 text-primary" strokeWidth={1.5} />
            </div>
            <div>
              <h3 className="font-default text-lg font-semibold tracking-tight text-foreground">
                Denver Metro Focused
              </h3>
              <p className="text-sm text-muted-foreground mt-1">
                Local Design-Build Expertise
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>;
}